import { Flex } from 'antd';
import React from 'react';
import SpellCheckerInput from '~/components/shared/SpellCheckerInput/SpellCheckerInput';

function TestPage() {
  return (
    <Flex className='h-full w-full p-l' vertical gap={32}>
      <SpellCheckerInput />
      <SpellCheckerInput textArea />
    </Flex>
  );
}

export default TestPage;
